import { useEffect } from 'react';
import { onAuthStateChanged, signInAnonymously } from 'firebase/auth';

export default function useAnonymousAuth(auth) {
  useEffect(() => {
    if (!auth) return undefined;

    // Persisted sessions (e.g. an admin login) restore from IndexedDB
    // asynchronously, so auth.currentUser can read null for a moment even
    // when a real session is about to load in. Reading it synchronously here
    // would sometimes sign in a throwaway anonymous user that then replaces
    // the real one once it resolves. Wait for Firebase's first resolved auth
    // state instead, and only act on it once.
    let active = true;
    let unsubscribe = () => {};

    unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!active) return;
      active = false;
      unsubscribe();

      if (!currentUser) {
        signInAnonymously(auth).catch((error) => {
          console.error('Anonymous auth error:', error);
        });
      }
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, [auth]);
}
